import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

export const useTranslations = () => {
  const { t, i18n } = useTranslation();

  const i18nT = (key) => {
    if (i18next.isInitialized) {
      return i18next.t(key);
    } else {
      console.warn('i18nT called before i18next was initialized');
      return key;
    }
  };

  return {
    t,
    i18nT
  };
};
